/** 系列类型 */
export const TYPE = 'waterfall';

/**
 * 至少2个堆叠柱状图才认为是瀑布图
 */
export const TWO_STACKED_COLUMN_CHARTS = 2;

/**
 * 至少3个数据项才认为是瀑布图
 */
export const THREE_DATA_ITEMS = 3;

export const HALF = 2;
